import React, { FC } from 'react';
import { M } from '@dashboard-experience/mastodon';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import Panel from '../../../Panels';
import {
  OccupationalHealthScreeningTest,
  OccupationalHealthScreening as OccupationalHealthScreeningType,
} from '../../../../types/report';
import {
  getOccupationalHealthCategorizedTestResults,
  showOccupationalHealthDispositionIndicator,
} from '../lib/utils';
import {
  ReportTable,
  ReportTableBody,
  ReportTableCell,
  ReportTableColumnHeader,
  ReportTableHead,
  ReportTableRow,
} from 'components/Reports/Report/MastodonReport/ReportTable';

interface Props {
  screening: OccupationalHealthScreeningType;
}

interface BodyProps {
  tests: OccupationalHealthScreeningTest[];
}

const OccupationalHealthScreening: FC<Props> = ({
  screening: { tests, status },
}) => {
  const categorizedTestResults =
    getOccupationalHealthCategorizedTestResults(tests);

  return (
    <Panel
      data-testid='health-screening-panel'
      title={i18n.getStr('components.healthScreening.healthScreening')}
      status={status}
      className='card-screening-results'
    >
      {categorizedTestResults.map(({ name, tests: filteredTests }) => (
        <div key={`category-${name}`} className='screening-results-category'>
          <div className='mb-4'>
            <strong>{name}</strong>
          </div>
          <ReportTable small>
            <ReportTableHead>
              <ReportTableRow>
                <ReportTableColumnHeader
                  className='text-very-muted'
                  width='40%'
                >
                  <T value='components.healthScreening.test' />
                </ReportTableColumnHeader>
                <ReportTableColumnHeader
                  className='text-very-muted'
                  width='60%'
                >
                  <T value='components.healthScreening.result' />
                </ReportTableColumnHeader>
              </ReportTableRow>
            </ReportTableHead>
            <ReportTableBody>
              <Body tests={filteredTests} />
            </ReportTableBody>
          </ReportTable>
        </div>
      ))}
    </Panel>
  );
};

const Body: FC<BodyProps> = ({ tests }) => (
  <>
    {tests.map(({ disposition, comment, name, status, slug }) => (
      <ReportTableRow key={`tr-${slug}`}>
        <ReportTableCell>{name}</ReportTableCell>
        <ReportTableCell>
          {showOccupationalHealthDispositionIndicator(disposition, status) && (
            <span className='disposition-indicator text-warning'>
              <M.Icon icon='InformationFilled' />{' '}
            </span>
          )}
          <span className='disposition'>{disposition}</span>
          {comment && <div className='text-very-muted'>{comment}</div>}
        </ReportTableCell>
      </ReportTableRow>
    ))}
  </>
);

export default OccupationalHealthScreening;
